import React from "react";
import { Menu, Loader } from "@mantine/core";
import { IconEye, IconDownload, IconTrash } from "@tabler/icons-react";
import { QR } from "../theme";
import useSharedStyles from "../sharedStyles";

// Kebab row-action menu for the main Reports list. Only "draft" (Awaiting
// Review) and "final" rows ever reach this list — the list endpoint excludes
// "failed" reports entirely (Story 1 AC), so there's no failed/retry branch
// here; retry lives on the dedicated Failed Reports page.
//
// Styled to match the prototype's .kebab / .row-menu exactly: the trigger is
// the literal "⋮" glyph (not an icon), and the dropdown's dimensions/shadow/
// item spacing and the danger (Delete) row's colors are all pinned via
// Menu's own stylesApi rather than Mantine's defaults.
const RowActionMenu = ({ status, onView, onDownload, onDelete, downloading, deleting }) => {
  const { classes } = useSharedStyles();
  const iconProps = { size: 15, color: QR.muted };

  return (
    <Menu
      position="bottom-end"
      withinPortal
      shadow="md"
      radius={10}
      styles={{
        dropdown: {
          minWidth: 190,
          padding: 6,
          border: `1px solid ${QR.line}`,
          boxShadow: "0 12px 32px rgba(15,23,42,.16)",
        },
        item: {
          display: "flex",
          alignItems: "center",
          gap: 10,
          padding: "9px 12px",
          borderRadius: 7,
          fontSize: 13,
          fontWeight: 500,
          color: QR.ink2,
          fontFamily: "Inter",
          "&:hover": { background: QR.surfaceSoft },
        },
        itemIcon: { marginRight: 0, width: 15, height: 15 },
        divider: { margin: "4px 0", borderTopColor: QR.lineSoft },
      }}
    >
      <Menu.Target>
        <button className={classes.kebab} onClick={(e) => e.stopPropagation()} aria-label="Row actions">
          ⋮
        </button>
      </Menu.Target>
      <Menu.Dropdown onClick={(e) => e.stopPropagation()}>
        <Menu.Item icon={<IconEye {...iconProps} />} onClick={onView}>
          {status === "final" ? "View report" : "View & edit"}
        </Menu.Item>
        <Menu.Item
          icon={downloading ? <Loader size={13} color={QR.muted} /> : <IconDownload {...iconProps} />}
          onClick={onDownload}
          disabled={downloading}
        >
          {downloading ? "Downloading…" : "Download PDF"}
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item
          icon={deleting ? <Loader size={13} color={QR.dangerDeep} /> : <IconTrash size={15} color={QR.dangerDeep} />}
          onClick={onDelete}
          disabled={deleting}
          styles={{
            item: { "&:hover": { background: QR.dangerSoft } },
          }}
        >
          <span className={classes.dangerText}>{deleting ? "Deleting…" : "Delete"}</span>
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default RowActionMenu;
